import styled from "styled-components";

interface CollapsibleProps {
  isVisible: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 65%;
  margin: 0;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 97%;
  gap: 1rem;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const CollapseButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  width: 100%;
  border-radius: 4px;
  background-color: #f8f8f8;
  color: black;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CollapsibleContent = styled.div<CollapsibleProps>`
  max-height: ${props => (props.isVisible ? "fit-content" : "0")};
  overflow: hidden;
  margin-left: 1rem;
  transition: max-height 0.3s ease;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
`;

export const SubmitContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 250px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const SmallText = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  color: #595959;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

export const OccurrenceContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;
export const OccurrenceCard = styled.div<{ disabled?: boolean; isSelected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  height: 78px;
  border: 1px solid ${props => (props.disabled ? "#d9d9d9" : props.isSelected ? "rgba(28, 91, 135, 1)" : "#1890ff")};
  border-radius: 8px;
  background-color: ${props => (props.disabled ? "#fafafa" : "#fff")};
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${props => (props.disabled ? 0.7 : 1)};
`;

export const OccurrenceContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormBox = styled.div`
  margin-bottom: 10px;

  width: 100%;
`;

export const OccurrenceLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
`;

export const OccurrenceDescription = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
`;

export const EventTypeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 30px;
    align-items: center;
  }
`;

export const EventTypeCard = styled.div<{ selected?: boolean; disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  width: 30%;
  height: 60px;
  border: 1px solid ${props => (props.selected ? "#1890ff" : "#d9d9d9")};
  border-radius: 8px;
  background-color: ${props => (props.disabled ? "#fafafa" : "#fff")};
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${props => (props.disabled ? 0.7 : 1)};

  @media (max-width: 768px) {
    width: 100%;
    padding: 20px;
  }
`;

export const EventTypeCardDisabled = styled.div<{ selected?: boolean; disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  width: 30%;
  height: 60px;
  border: 1px solid ${props => (props.selected ? "#1C5B87" : "#d9d9d9")};
  border-radius: 8px;
  background-color: ${props => (props.disabled ? "#fafafa" : "#fff")};
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${props => (props.disabled ? 0.7 : 1)};

  @media (max-width: 768px) {
    width: 100%;
    padding: 20px;
  }
`;

export const Right = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => (visible ? "block" : "none")};
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const EventTypeLabel = styled.p<{ selected?: boolean }>`
  margin-top: 0;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: ${({ selected }) => (selected ? "#1C5B87" : "initial")};
`;

export const EventTypeDescription = styled.p<{ selected?: boolean }>`
  margin-top: 0;
  margin-bottom: 0;
  color: ${({ selected }) => (selected ? "#1C5B87" : "#888")};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
`;

export const CardDisabled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

export const ComingSoonButton = styled.div`
  padding: 2px 5px;
  background-color: #fffefa;
  color: #665000;
  border: 1px solid;
  border-color: #f1f1f1;
  border-radius: 8px;
  font-size: 9px;
  cursor: not-allowed;
  margin-left: auto;
  margin-right: 0.5rem;
`;

export const SuggestionsDropdown = styled.ul`
  position: absolute;
  z-index: 1000;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

export const SuggestionItem = styled.li`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const TicketStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: rgba(249, 251, 255, 1);
  justify-content: space-between;
  border-radius: 10px;
  padding: 0.5rem;
  margin-bottom: 50px;
  max-width: 500px;
`;
export const StatusLeft = styled.div`
  display: flex;
  flex-direction: column;
`;
export const StatusRight = styled.div``;
export const SmallerText = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: #595959;
`;
